import React, { useState } from "react";
import Carousel from "react-material-ui-carousel";
import { Paper } from "@mui/material";
import { DefaultSettingsT, SettingsT } from "./MobileSliderSettings";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";
import { MbaMobileimg7 } from "../mbaContent/mbaMobileCon7";
import { MbaMobileimg8 } from "../mbaContent/mbaMobileCon8";
import { MbaMobileimg9 } from "../mbaContent/mbaMobileCon9";
import { MbaMobileimg10 } from "../mbaContent/mbaMobileCon10";
import { MbaMobileimg11 } from "../mbaContent/mbaMobileCon11";
import { MbaMobileimg12 } from "../mbaContent/mbaMobileCon12";

const useStyles = makeStyles((theme: Theme) => ({
  secondExaple: {
    maxWidth: "500px",
  },
  project: {
    maxWidth: "100%",
    position: "relative",
    // height: "300px",
    overflow: "hidden",
    padding: "22px",
  },
  checkButton: {
    marginTop: "40px",
    color: "white",
    fontSize: 16,
    border: "3px solid white",
    textTransform: "capitalize",
  },
}));

const MobileSliderMBA2 = () => {
  const classes = useStyles();

  const [settings] = useState<SettingsT>(DefaultSettingsT);

  return (
    <div style={{ marginTop: "5px", color: "#494949" }}>
      <Carousel
        className={classes.secondExaple}
        {...settings}
        navButtonsProps={{
          style: { backgroundColor: "white" },
        }}
      >
        {items.map((item, index) => {
          return <Project item={item} key={index} />;
        })}
      </Carousel>
    </div>
  );
};

type Item = {
  name?: string;
  description?: string;
  color?: string;
  href?: string;
  content?: any;
};

interface ProjectProps {
  item: Item;
}

function Project({ item }: ProjectProps) {
  const classes = useStyles();

  return (
    <Paper
      className={classes.project}
      style={{
        backgroundColor: item.color,
        boxShadow: "none",
      }}
      elevation={10}
    >
      {/* <Typography variant="h5">{item.name}</Typography>
      <br />
      <Typography>{item.description}</Typography> */}
      {item.content}
      {/* <Button
        className={classes.checkButton}
        component="a"
        href={item.href}
        target="_blank"
        rel="noreferrer"
      >
        Check it out!
      </Button> */}
    </Paper>
  );
}

const items: Item[] = [
  {
    // name: "",
    // description: "",
    // color: "#64ACC8",
    // href: "",
    content: <MbaMobileimg7 />,
  },
  {
    // name: "",
    // description: "",
    // color: "#7D85B1",
    // href: "",
    content: <MbaMobileimg8 />,
  },
  {
    // name: "",
    // description: "",
    // color: "#CE7E78",
    // href: "",
    content: <MbaMobileimg9 />,
  },
  {
    // name: "",
    // description: "",
    // color: "#C9A27E",
    // href: "",
    content: <MbaMobileimg10 />,
  },
  {
    // name: "",
    // description: "",
    // color: "#C9A27E",
    // href: "",
    content: <MbaMobileimg11 />,
  },
  {
    // name: "",
    // description: "",
    // color: "#C9A27E",
    // href: "",
    content: <MbaMobileimg12 />,
  },
];

export default MobileSliderMBA2;
